// /participations DataGrid 컬럼 정의.
// flex 전면 제거 → width + minWidth 고정.

import React from "react";
import { Link } from "react-router-dom";
import type { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { OverflowTooltip } from "components/list";
import { IParticipation } from "../interfaces";

const linkStyle: React.CSSProperties = {
  textDecoration: "underline",
  fontWeight: 600,
  color: "var(--color-primary)",
};

export const participationColumns: GridColDef<IParticipation>[] = [
  {
    field: "id",
    headerName: "ID",
    type: "number",
    width: 84,
    minWidth: 72,
    align: "center",
    headerAlign: "center",
  },
  // status는 실제 enum 값을 확인하기 전까지 원본 그대로 평문 표시(기존 동작 유지)
  {
    field: "status",
    headerName: "상태",
    type: "string",
    width: 140,
    minWidth: 100,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "parentId",
    headerName: "학부모 ID",
    type: "string",
    width: 120,
    minWidth: 100,
    renderCell: (params: GridRenderCellParams) => (
      <OverflowTooltip value={params.value}>
        <Link to={`/parents/show/${params.row.parentId}`} style={linkStyle}>
          {params.value}
        </Link>
      </OverflowTooltip>
    ),
  },
  {
    field: "ptDateId",
    headerName: "신청한 설명회 ID",
    type: "string",
    width: 150,
    minWidth: 120,
    renderCell: (params: GridRenderCellParams) => (
      <OverflowTooltip value={params.value}>
        <Link to={`/ptDates/show/${params.row.ptDateId}`} style={linkStyle}>
          {params.value}
        </Link>
      </OverflowTooltip>
    ),
  },
  {
    field: "updatedDate",
    headerName: "수정일",
    type: "string",
    width: 150,
    minWidth: 120,
    align: "center",
    headerAlign: "center",
  },
];
